import React from 'react';

import CrossCircle from '@ast/magma/components/icon/icons/TimesCircle';

import { Button } from '@ast/magma/components/button';
import { Dialog } from '@ast/magma/components/dialog';

import { useIsMobile } from '@app/common/utils/hooks/useIsMobile';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import styles from './Dialog.pcss';
import { useEscapeCloseHandler } from './useEscapeCloseHandler';

interface ErrorDialogProps {
  readonly onClose: () => void
}
export const ErrorDialog = ({ onClose }: ErrorDialogProps) => {
  const { t } = useUserSettingsTranslation();

  const isMobile = useIsMobile();

  useEscapeCloseHandler(onClose);

  return (
    <Dialog
      align={isMobile ? 'bottom' : 'center'}
      predefinedWidth="sm"
      data-stable-name="RegisteredPasskeyErrorDialog"
      status={{
        icon: <CrossCircle />,
        level: 'error',
      }}
    >
      <div className={styles.dialog}>
        <div
          className={styles.dialogTitle}
          data-stable-name="RegisteredPasskeyErrorTitle"
        >
          {t(
            'profile-and-security.register-passkey-error.dialog.content.title|Title of content in dialog',
            'Adding the passkey failed',
          )}
        </div>
        <div className={styles.dialogContent}>
          <div
            className={styles.text}
            data-stable-name="RegisteredPasskeyErrorContent"
          >
            {t(
              'profile-and-security.register-passkey-error.dialog.content.error-message|Error message',
              'Sorry, a server error occurred',
            )}
          </div>

          <Button
            data-stable-name="CloseButton"
            look="outlined"
            onClick={onClose}
          >
            {t(
              'profile-and-security.register-passkey-error.error-dialog.close-button|Close button label',
              'Close',
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
